import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useMemo } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { ListingDetailsContainer } from '../../containers/ListingDetails';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function SolutionsPartnersSearchResultsProxy() {
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const {
    PROFILE_CATALOG_SERVICES,
    PROFILE_INDUSTRIES,
    loading
  } = useFilterConfig();
  const {
    params,
    isProfilePage
  } = useMemo(() => {
    if (loading) {
      return {
        params: new URLSearchParams(),
        isProfilePage: false
      };
    }
    const urlParams = new URLSearchParams(location.search);
    if (parsedPathParams.page) {
      urlParams.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    }
    if (parsedPathParams.categorySlug && parsedPathParams.categorySlug !== 'all') {
      const serviceMatch = PROFILE_CATALOG_SERVICES === null || PROFILE_CATALOG_SERVICES === void 0 ? void 0 : PROFILE_CATALOG_SERVICES.options.find(o => o.slug === parsedPathParams.categorySlug);
      if (serviceMatch && PROFILE_CATALOG_SERVICES) {
        urlParams.set(`${KEY_PREFIX}${PROFILE_CATALOG_SERVICES.field}`, serviceMatch.value);
      }
      const industryMatch = PROFILE_INDUSTRIES === null || PROFILE_INDUSTRIES === void 0 ? void 0 : PROFILE_INDUSTRIES.options.find(o => o.slug === parsedPathParams.categorySlug);
      if (industryMatch && PROFILE_INDUSTRIES) {
        urlParams.set(`${KEY_PREFIX}${PROFILE_INDUSTRIES.field}`, industryMatch.value);
      }

      // If the slug doesn't match any category filter, treat it as a
      // partner profile slug and let the profile page render.
      if (!serviceMatch && !industryMatch) {
        return {
          params: urlParams,
          isProfilePage: true
        };
      }
    }
    return {
      params: urlParams,
      isProfilePage: false
    };
  }, [PROFILE_CATALOG_SERVICES, PROFILE_INDUSTRIES, loading, location.search, parsedPathParams]);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  if (isProfilePage) {
    return /*#__PURE__*/_jsx(ListingDetailsContainer, {});
  }
  const search = params.toString();
  return /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: search ? `?${search}` : ''
    }
  });
}